import type { DateValue } from '@internationalized/date';
import { Writable, writable } from 'svelte/store';

import type { DateInfos } from './types';

export const dateValue: Writable<DateValue | undefined> = writable(undefined);

export const selectedPrice: Writable<{
    originalPrice: number | null; // formatCurrency(date.price) ou null (hidden)
    rebateAmount: string | null; // date.rebateAmount ou null (hidden)
    actualPrice: number | null; // date.rebatedPrice OU date.price
}> = writable({
    originalPrice: null,
    rebateAmount: null,
    actualPrice: null,
});

export const datesInfos = writable<DateInfos>({
    price: null,
    remainingStock: null, // gir only
    statusName: '', // gir only
    selectedDate: null, // gir only, for fit use dateValue
});

export const isModalOpen = writable(false);
export const modalStep = writable(1);
